import React from 'react';
import './AboutUs.css';
import teamImage from '../assets/aboutusteam.png';
import { motion } from 'framer-motion';

const AboutUs = () => {
  return (
    <motion.section
      className="about-us"
      id="about-us"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className="about-us-content">
        <motion.div
          className="about-us-text"
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <motion.h1
            animate={{ y: [0, -10, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            Who We Are
          </motion.h1>
          <motion.h2
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            About JN IT Digital Solutions
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            JN IT Digital Solutions is a passionate team of marketing strategists, creative designers, and technical experts. We specialize in SEO, SEM, social media, influencer marketing, and lead generation in Andhra Pradesh. Our approach is collaborative and transparent. Every project we take on is fueled by data, innovation, and a commitment to measurable results. We believe quality is non-negotiable. From startups to established businesses, we craft customized solutions. We prioritize performance, engagement, and ROI. Our team adapts to trends while staying rooted in ethical practices. We work smart, fast, and focused — putting our clients first. Your success defines ours. With clear communication and consistent reporting, we build trust and accountability. JN IT is not just a service provider — we're your growth partner.
          </motion.p>
        </motion.div>
        <motion.div
          className="about-us-image"
          initial={{ x: 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <motion.img
            src={teamImage}
            alt="JN IT Team"
            whileHover={{ scale: 1.05, rotate: 2 }}
            transition={{ type: "spring", stiffness: 300 }}
          />
        </motion.div>
      </div>
    </motion.section>
  );
};

export default AboutUs;
